// extracted by mini-css-extract-plugin
export default {"switch__wrapper":"FormWrapper_switch__wrapper__dEJ5w"};